const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `${keyword}`, // 确认后输入的内容
    ...ext
  }
}

/**
 * 官方布尔内建函数
 * 数据来源：http://freemarker.foofun.cn/ref_builtins_boolean.html
 * @author Caesar Liu
 * @date 2020-11-20 14:58
 */
module.exports = [
  buildConfig('then', {
    documentation: [
      '类三元表达式',
      'e.g: ${true?then("Y", "N")}',
      '返回"Y"'
    ].join('\n')
  })
]
